import React, { Component, PropTypes } from 'react';
import ErrorField from '../ErrorField';
import Checkbox from '../Checkbox';
import './MultiSelect.css';


class MultiSelect extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  handleChange(index, val) {
		const { handleClick, field } = this.props;
    handleClick(field.name, index, val)
  }

  handleFocus() {
    this.props.handleFocus(this.props.field.name)
  }

  handleBlur() {
    this.props.handleBlur(this.props.field.name)
  }

  render() {
    const { field } = this.props;
    return (
				<div className="input-field-wrap">
					<h2 className="multiselect__title">{field.placeholder}</h2>
					<div className="multiselect">
						{
							field.value.map((opt, index) => {
								return (
									<Checkbox
										choice={opt.name}
										isGreen={true}
										index={index}
										field={field}
										handleClick={this.handleChange}/>
								)
							})
						}
					</div>
					<ErrorField hasBlurred={field.hasBlurred} error={field.error}/>
				</div>
    );
  }
}

MultiSelect.propTypes = {
  field: PropTypes.shape({
      value: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
      ]),
      placeholder: PropTypes.string.isRequired,
      hasBlurred: PropTypes.bool.isRequired,
      inputType: PropTypes.string.isRequired,
      breed: PropTypes.string.isRequired
    }),
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired
};

export default MultiSelect;



/** WEBPACK FOOTER **
 ** ./src/components/MultiSelect/index.js
 **/